<template>
  <div :class="divWidthChange" class="conteudoWidth fccUsuarios">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div>
      <b-card-group deck class="my-3">
        <b-card class="mb-3" no-body>
          <b-card-header class="font-weight-bold"> Consulta </b-card-header>
          <b-card-text class="p-4">
            <form @submit.prevent="mostraLog()">
              <b-row class="row py-3 datasLogs">
                <b-col cols="4">
                  <fccSelect
                    @change="mudaTable()"
                    required
                    labelField="valor"
                    valueField="id"
                    :options="tiposLogs"
                    v-model="dataLog.tipoLog"
                    >Tipo de log</fccSelect
                  >
                </b-col>
                <b-col cols="4">
                  <fccSelect
                    :disabled="dataLog.tipoLog == 1"
                    @change="mudaTable()"
                    labelField="usuid"
                    valueField="usuid"
                    :options="usuarioListando"
                    v-model="dataLog.nome"
                    >Usuários</fccSelect
                  >
                </b-col>
              </b-row>
              <b-row class="row py-3 datasLogs">
                <b-col cols="4">
                  <fccDateInput
                    class="form-control dateLog"
                    type="datetime"
                    v-model="dataLog.dataInicio"
                    required
                    >Data inicial</fccDateInput
                  >
                </b-col>
                <b-col cols="4">
                  <fccDateInput
                    @input="checkDatas()"
                    class="form-control dateLog"
                    type="datetime"
                    v-model="dataLog.dataFinal"
                    required
                    >Data final</fccDateInput
                  >
                </b-col>
                <b-col cols="2">
                  <fccButton tipo="submit" color="outline-primary">Consultar</fccButton>
                </b-col>
              </b-row>
            </form>
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>

    <div v-if="responseLog != false">
      <fccTable
        striped
        hover
        :fields="fieldGrupo"
        responsive
        search
        pagination
        fieldVisibility
        pdf
        csv
        xls
        :actions="actionsLog"
        :items="responseLog"
      >
      </fccTable>
    </div>
    <fccModal
      centered
      idModal="listaLogs"
      size="lg"
      :titleModal="titlePage"
      escondeFooter
      travaEsc
      travaBack
    >
      <div class="container_header"></div>
      <fccButton @click="ImpressaoData()" class="float-right">Imprimir</fccButton>
      <div v-if="log.exception" class="p-3" id="printando">
        <p><span class="font-weight-bold">ID:</span> {{ log.id }}</p>
        <p><span class="font-weight-bold">Data:</span> {{ log.date }}</p>
        <p><span class="font-weight-bold">Usuário:</span> {{ log.logger }}</p>
        <p><span class="font-weight-bold">Tipo:</span> {{ log.level }}</p>
        <hr style="border-bottom: 1px solid black" />
        <p><span class="font-weight-bold">Logger: </span>{{ log.logger }}</p>
        <p><span class="font-weight-bold">Message:</span>{{ log.message }}</p>
        <p><span class="font-weight-bold">Exception:</span></p>
        <div v-if="log.exception.message">
          <p>
            <span class="font-weight-bold">Mensagem:</span><br />
            {{ log.exception.message }}
          </p>
        </div>
        <p v-if="log.exception.message">
          <span class="font-weight-bold">Base Message:</span> {{ log.exception.basemessage }}
        </p>
        <p>
          <span class="font-weight-bold">Text:</span>
          {{ log.exception.text }}
        </p>
        <p><span class="font-weight-bold">Type:</span> {{ log.exception.type }}</p>
        <p><span class="font-weight-bold">Hresult:</span> {{ log.exception.hresult }}</p>
        <p><span class="font-weight-bold">Source:</span> {{ log.exception.source }}</p>
        <p><span class="font-weight-bold">Method Name:</span> {{ log.exception.methodname }}</p>
        <p><span class="font-weight-bold">Module Name:</span> {{ log.exception.modulename }}</p>
        <p>
          <span class="font-weight-bold">Module Version:</span> {{ log.exception.moduleversion }}
        </p>
        <p><span class="font-weight-bold">Error Code:</span> {{ log.exception.errorcode }}</p>
        <hr style="border-bottom: 1px solid black" />
        <p><span class="font-weight-bold">Data da Impressão: </span>{{ dataAtual }}</p>
      </div>

      <div v-else id="printando">
        <p><span class="font-weight-bold">Usuário:</span> {{ log.usuario }}</p>
        <p><span class="font-weight-bold">Data:</span> {{ log.data }}</p>
        <p><span class="font-weight-bold">Tipo:</span> {{ tipoDeLogs }}</p>
        <p><span class="font-weight-bold">ID:</span> {{ log.id }}</p>
        <p style="word-wrap: break-word">
          <span class="font-weight-bold">Token:</span>
          {{ log.token }}
        </p>

        <hr style="border-bottom: 1px solid black" />
        <p><span class="font-weight-bold">Data da Impressao: </span>{{ dataAtual }}</p>
      </div>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
import './../assets/fccUsuarios.scss'
export default {
  data() {
    return {
      dataAtual: '',
      titlePage: 'Logs',
      dataLog: {},
      log: {},
      tiposLogs: [],
      responseLog: [],
      fieldGrupo: [],
      fieldsGrupoUm: [
        { key: 'logger', label: 'Usuário', sortable: true, active: true },
        { key: 'date', label: 'Data', sortable: true, active: true },
        { key: 'level', label: 'Tipo', sortable: true, active: true },
        { key: 'id', label: 'ID', sortable: true, active: true },
        { key: 'actions', label: '', active: true }
      ],
      fieldsGrupoDois: [
        { key: 'usuario', label: 'Usuário', sortable: true, active: true },
        { key: 'data', label: 'Data', sortable: true, active: true },
        {
          key: 'nomelog',
          label: 'Nome do Log',
          sortable: true,
          active: true,
          formatter(data) {
            const limitText =
              data.length > 30 ? data.substring(0, 30) + '...' : data.substring(0, 30)
            return limitText
          }
        },
        { key: 'id', label: 'ID', sortable: true, active: true },
        {
          key: 'token',
          label: 'Token',
          sortable: true,
          active: true,
          formatter(data) {
            const limitText =
              data.length > 30 ? data.substring(0, 30) + '...' : data.substring(0, 30)
            return limitText
          }
        },
        { key: 'actions', label: '', active: true }
      ],
      actionsLog: [
        {
          button: true,
          funcaoButton: 'subLog',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  computed: {
    tipoDeLogs() {
      if (this.dataLog.tipoLog) {
        return this.tiposLogs[this.dataLog.tipoLog - 1].valor
      } else {
        return undefined
      }
    }
  },
  methods: {
    ImpressaoData() {
      this.printElement('printando')
    },
    mudaTable() {
      this.responseLog = []
      if (this.dataLog.tipoLog == 1) {
        this.fieldGrupo = this.fieldsGrupoUm
        this.dataLog.nome = null
      } else {
        this.fieldGrupo = this.fieldsGrupoDois
      }
    },

    checkDatas() {
      if (this.dataLog.dataInicio > this.dataLog.dataFinal) {
        this.callAlert('', 'A data final não pode ser menor que a data inicial', 'error', 'error')
        this.carregaTexto()
        return
      }
    },
    mostraLog() {
      this.carregaTexto(this.codeMensagem('C01'))
      if (this.dataLog.dataInicio > this.dataLog.dataFinal) {
        this.callAlert('', 'A data final não pode ser menor que a data inicial', 'error', 'error')
        this.carregaTexto()
        return
      } else {
        axios
          .get(
            this.baseUrlGestaoProjetosConcurso +
              'Logs/listarporfaixadedatas?tipoLog=' +
              this.dataLog.tipoLog +
              '&ini=' +
              this.dataLog.dataInicio +
              '&fim=' +
              this.dataLog.dataFinal +
              (this.dataLog.nome == null ? '' : '&usuID=' + this.dataLog.nome),
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.responseLog = response.data
            this.carregaTexto()
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      }
    },

    subLog(_, item) {
      this.dataAtual = this.$moment().format('DD/MM/YYYY HH:mm:ss')
      this.log = { ...item }
      this.$root.$emit('bv::show::modal', 'listaLogs')
    },
    listarTipoLogs() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlGestaoProjetosConcurso + 'Logs/listartiposlogs',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.tiposLogs = response.data
          this.carregaTexto()
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    }
  },
  mounted: function () {
    this.baseUrlGestaoProjetosConcurso = store.state.baseUrlGestaoProjetos
    this.listarTipoLogs()
    this.usuariosListando()
  }
}
</script>

     